import styled, { css } from "styled-components"
import { SecondaryHeading } from "../../../components/common/heading.component"
import {
  BasicButtonLink,
  NeutralRawLink,
} from "../../../ui/components/link/link.component"

export const TitleWrapper = styled(NeutralRawLink)`
  flex: 3;

  @media (min-width: ${({ theme }) => theme.breakpoint.tabletHorizontal}px) {
    min-width: 190px;
    flex: 2;
  }
`

export const ArrowButton = styled.div<{ active: boolean }>`
  z-index: 3;
  width: 30px;
  height: 30px;
  display: flex;
  cursor: pointer;
  position: relative;
  margin-right: -3px;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease-in-out;
  ${({ active }) => !active && `transform: rotateZ(180deg);`};

  @media (min-width: ${({ theme }) => theme.breakpoint.tabletHorizontal}px) {
    margin-right: 25px;
  }

  @media (min-width: ${({ theme }) => theme.breakpoint.tabletHorizontal}px) {
    display: none;
  }

  svg {
    width: 20px;
    transform: rotateZ(-90deg);
  }
`

export const List = styled.ul<{ active: boolean }>`
  left: 0;
  margin: 0;
  top: 100%;
  width: 100%;
  z-index: 1;
  display: flex;
  padding: 20px;
  opacity: 0;
  list-style: none;
  position: absolute;
  box-sizing: border-box;
  flex-direction: column;
  transform-origin: top center;
  transition: all 0.3s ease-in-out;
  transform: translateY(calc(-100% - 22px));
  box-shadow: 0 2px 20px 0 ${({ theme }) => theme.color.lightShadow};
  background-color: ${({ theme }) => theme.color.backgroundInverted};
  flex: 8;
  align-self: stretch;
  align-items: stretch;
  justify-content: center;

  ${({ active }) =>
    active &&
    `
    opacity: 1;
    transform: translateY(0);
  `};

  @media (min-width: ${({ theme }) => theme.breakpoint.tablet}px) {
    padding: 20px 45px;
  }

  @media (min-width: ${({ theme }) => theme.breakpoint.tabletHorizontal}px) {
    opacity: 1;
    top: 0;
    padding: 0;
    width: auto;
    box-shadow: none;
    position: relative;
    align-items: center;
    flex-direction: row;
    transform: translateY(0);
  }

  li {
    @media (max-width: ${({ theme }) =>
        theme.breakpoint.tabletHorizontal - 1}px) {
      &:not(:first-of-type) {
        margin-top: 20px;
      }
    }

    @media (min-width: ${({ theme }) => theme.breakpoint.tabletHorizontal}px) {
    }

    @media (min-width: ${({ theme }) =>
        theme.breakpoint.tabletHorizontal + 60}px) {
      padding: 0 20px;
    }

    @media (min-width: ${({ theme }) => theme.breakpoint.desktop}px) {
      padding: 0 30px;
    }
  }
`

export const Wrapper = styled.nav<{ isFullWidth?: boolean }>`
  z-index: 6;
  width: calc(100% - 40px);
  display: flex;
  margin: 0 auto;
  max-width: ${({ isFullWidth }) => (isFullWidth ? "1920px" : "1260px")};
  position: relative;
  align-items: center;
  flex-direction: row;
  justify-self: center;
  height: var(--height);
  box-sizing: border-box;
  justify-content: space-between;
  transform: translate3d(0, 0, 0);

  ${SecondaryHeading} {
    flex: 1;
    z-index: 3;
    font-size: 20px;
    position: relative;
  }

  @media (max-width: ${({ theme }) =>
      theme.breakpoint.tabletHorizontal - 1}px) {
    &:before {
      top: 0;
      left: 0;
      z-index: 2;
      content: "";
      width: 100%;
      height: 100%;
      display: block;
      position: absolute;
      background-color: ${({ theme }) => theme.color.backgroundInverted};
    }
    ${BasicButtonLink} {
      z-index: 3;
      padding: 0 20px;
      position: relative;
    }
  }
`

export const StaticContainer = styled.div`
  height: var(--height);
  --height: ${({ theme }) => theme.size.secondaryHeaderMobile}px;

  @media (min-width: ${({ theme }) => theme.breakpoint.tabletHorizontal}px) {
    --height: ${({ theme }) => theme.size.secondaryHeaderDesktop}px;
  }

  @media (min-width: 960px) {
    margin-top: -60px;
    margin-bottom: 30px;
  }
`

export const StickyContainer = styled.div<{ sticky: boolean }>`
  height: var(--height);
  background-color: ${({ theme }) => theme.color.backgroundInverted};
  border-bottom: 1px solid transparent;
  transition: border 0.15s ease-in-out;

  ${({ sticky }) =>
    sticky &&
    css`
      top: 0;
      left: 0;
      z-index: 9;
      width: 100%;
      position: fixed;
      border-bottom: 1px solid ${({ theme }) => theme.color.borderLight};
    `};
`

export const SubmenuButton = styled.div<{ active: boolean }>`
  @media (max-width: ${({ theme }) =>
      theme.breakpoint.tabletHorizontal - 1}px) {
    margin-right: 13px;
    ${BasicButtonLink} {
      padding: 8px 12px;
    }
  }

  a,
  > div {
    padding-left: 20px;
    transition: all 0.15s ease-in-out;
    opacity: ${({ active }) => (active ? 1 : 0)};
    visibility: ${({ active }) => (active ? `visible` : `hidden`)};
  }
`

export const InlineContainer = styled.div`
  display: inline-flex;
  flex: 2;
  justify-content: flex-end;
`
